import React from 'react';

const HistoryIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 160 160"
    className={className}
    width="1em"
    height="1em"
  >
    <g>
      <path
        d="M82.5,15.31c29.33.75,62.83,25.37,62.83,62.83,0,34.7-28.13,62.83-62.83,62.83s-62.83-28.13-62.83-62.83"
        fill="white"
        stroke="currentColor"
        strokeWidth="11"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
      <path
        d="M78.67,46.79c.22,6.03,0,28.12,0,28.12,0,0,18.47,25.26,20.09,26.79"
        fill="none"
        stroke="currentColor"
        strokeWidth="11"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
      <path
        d="M28.21,85.62c-1.12-1.51-7.3-9.88-8.43-11.24-.06-.08-.17-.07-.23,0-1.07,1.45-6.72,9.77-7.73,11.27-.07.1,0,.23.13.23l16.14-.03c.12,0,.2-.14.12-.23Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="11"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
    </g>
  </svg>
);

};

export default HistoryIcon;
